<template>
  <svg
    viewBox="0 0 27.73 27.73"
    class="svg-caret"
  >
    <path
      height="30px"
      d="M8.87,11.54l4.99,5l5-5"
    />
  </svg>
</template>

<script>
export default {
  name: 'CaretIcon',
};
</script>
<style scoped lang="scss">
svg {
  cursor: pointer;
  transform: scale(1.5);
  fill: none;
  stroke: main.$npGray;
}
</style>
